// material-ui
// third party
// project imports
import React, { useState } from "react";
import RechargeForm from "./RechargeForm";
import SuccessResult from "./SuccessResult";

interface Props {
    handleDrawerChangeState: () => void;
}

// ==============================|| MEMBERS - FORM FOR EDIT/VIEW ||============================== //

interface Props {
    handleDrawerChangeState: () => void;
    isDeleteEnabled?: boolean;
    memberId?: string;
}

const RechargeRegistrationFormLayout = ({ handleDrawerChangeState, isDeleteEnabled, memberId }: Props) => {

    const [showSuccessResult, setSuccessResult] = useState(false)
    const [rechargedMemberId, setRechargedMemberId] = useState('')
    return (
        <>
            {
                showSuccessResult && (
                    <SuccessResult setSuccessResult={setSuccessResult} handleDrawerChangeState={handleDrawerChangeState}
                                   rechargedMemberId={rechargedMemberId} />
                )
            }
            {
                !showSuccessResult && (
                    <RechargeForm handleDrawerChangeState={handleDrawerChangeState} isDeleteEnabled={isDeleteEnabled}
                                  setSuccessResult={setSuccessResult} setRechargedMemberId={setRechargedMemberId}
                                  memberId={memberId} />
                )
            }
        </>
    );
};
export default RechargeRegistrationFormLayout;